<template>
  <v-container>
    <v-row>

      <v-col cols="8">
    <v-switch v-for="feature in features" 
      :label="feature.name"
      :input-value="hasProduct(feature.value)"
      @change="setProduct(feature.value, $event)"
      :key="feature.value"
      :disabled="feature.disabled"
    ></v-switch>
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="8">
            <v-tabs>
              <template v-if="olbEnabled">
            <v-tab>
              MH1 Online Bookings Config
            </v-tab>
              <v-tab-item>

<v-container>

        <v-row
        align="baseline"
      >
        <v-col cols="8">
          <v-text-field
            required
            :rules="[v => !!v || 'Notification Channel']"
            label="Notification Channel"
            v-model="value.notificationChannel"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row
        align="baseline"
      >
        <v-col cols="8">
          <v-text-field
            required
            :rules="[v => !!v || 'WS Subscriber Username']"
            label="WS Subscriber Username"
            v-model="value.username"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row
        align="baseline"
      >
        <v-col cols="8">
          <v-text-field
            type="password"
            required
            :rules="[v => !!v || 'WS Subscriber Password']"
            label="WS Subscriber Password"
            v-model="value.encryptedPassword"
            :readonly="true"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-btn @click="setPassword()">Set Password</v-btn>
        </v-col>
      </v-row>

      <v-row align="baseline">
        <v-col cols="8">
          <v-autocomplete
            v-model="value.timeZone"
            :items="timeZoneNames"
            label="Time Zone"
            required
            :rules="[v => !!v || 'Timezone is required']"
          ></v-autocomplete>
        </v-col>
        <v-col cols="4">
          <span></span>
        </v-col>
      </v-row>
</v-container>

              </v-tab-item>
              </template>
              <!--
              <template v-if="mh1ErEnabled">

            <v-tab>
              MH1 EasyRecalls Config
            </v-tab>
              <v-tab-item>

<v-select label="MH1 Practice for EasyRecalls" :items="pmsInfo.sites" item-text="name" item-value="pmsSiteId" v-model="value.features.mh1EasyRecalls.pmsSiteId"></v-select>

              </v-tab-item>
              </template>
              -->
            </v-tabs>
        </v-col>
    </v-row>
  </v-container>
</template>
<script>

import { timeZonesNames } from "@vvo/tzdb";


import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";

export default {
  name: "SelectFeatures",
  props: {
    value: Object,
    pmsInfo: Object,
    index: Number,
  },
  created: function () {
    // this is always valid as one feature has to be selected
    this.timeZoneNames = timeZonesNames;
    this.$emit("step-is-valid", 1);
  },
  computed: {
    mh1ErEnabled: function() {
      return this.value.products.find(p => p?.trim()?.toLowerCase() == "mh1easyrecalls") ? true : false;
    },
    olbEnabled: function() {
      return this.value.products.find(p => p?.trim()?.toLowerCase() == "olb") ? true : false;
    }

  },
  watch: {
    value: async function (newVal, oldVal) {
      if (
        newVal.newOrExisting == "existing" && newVal.existingMh1PracticeId && 
        newVal.existingMh1PracticeId != oldVal.existingMh1PracticeId
      ) {
        //this.value.features.pms = newVal.existingMh1PracticeId;
      }
    }
  },
  methods: {
    hasProduct: function(productCode) {
      const hasProduct = this.value.products.find(p => p?.trim()?.toLowerCase() === productCode) ? true : false;
      console.log("hasProduct", productCode, this.value.products, hasProduct);
      return hasProduct;
    },
    setProduct: function(productCode, event) {
      console.log("setProduct", productCode, event);
      
      if (event) {
        if (this.value.products.find(p => p?.trim()?.toLowerCase() === productCode)) return;

        this.value.products.push(productCode);
      }
      else {
        const currentProductIndex = this.value.products.map(p => p?.trim()?.toLowerCase()).indexOf(productCode?.toLowerCase());
        console.log("setProduct remove", currentProductIndex, this.value.products.map(p=> p?.trim()?.toLowerCase()).indexOf(productCode?.toLowerCase()));
        if (currentProductIndex < 0) return;

        this.value.products.splice(currentProductIndex, 1);
        
      }

    },
    async setPassword() {
      try {

        const res = await this.$dialog.prompt({
          title: "WS Account Password",
          text: "Please enter the WS account password",
        });

        console.log("setPassword prompt response", res);

        if (!res) {
          return;
        }

        const encResponse = await API.graphql(
          graphqlOperation(queries.encryptValue, { input: res })
        );

        console.log("setPassword got response", encResponse);

        const r = encResponse?.data?.encryptValue?.data;

        if (!r) {
          const notifyResult = await this.$dialog.notify.error(
            "Error setting password",
            {
              position: "top-right",
              timeout: 5000,
              actions: [{ text: "Info", "x-small": true, color: "secondary" }],
            }
          );

          if (notifyResult == "Info") {
            this.$dialog.error({
              text:
                encResponse?.data?.encryptValue?.error ??
                JSON.stringify(encResponse),
              title: "Cannot set password",
              icon: "mdi-error",
            });
          }
          return;
        }

        console.log("setPassword parsed response", r);

        this.value.encryptedPassword = r;
      } catch (err) {
        const notifyResult = await this.$dialog.notify.error(
          "Error setting password",
          {
            position: "top-right",
            timeout: 5000,
            actions: [{ text: "Info", "x-small": true, color: "secondary" }],
          }
        );

        if (notifyResult == "Info") {
          this.$dialog.error({
            text: JSON.stringify(err),
            title: "Cannot set password",
            icon: "mdi-error",
          });
        }
      }
    },
  },
  data: function () {
    return {
      mh1EasyRecallsPmsSiteId: "",
      features: [
        {
          name: "MH1 Online Appointments",
          value:"olb",
          disabled: true

        }/*,
        {
          name: "MH1 EasyRecalls",
          value: "mh1EasyRecalls",
        }*/
      ],
      timeZoneNames: [],
      notificationChannel: "",
      timeZone: "",
      wsUsername: "",
      wsPassword: "", 
    };
  },
};
</script>